function initQuantityCart() {
  // @ts-ignore
  window.woo_cart_update = () => {
    const updateCartButton = document.querySelector("[data-woo-cart-update-button]") as HTMLElement;

    if (!updateCartButton) return;

    updateCartButton.removeAttribute("disabled");
    updateCartButton.click();
  };
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    initQuantityCart();
  },
  {
    once: true,
  }
);
